import { useState } from "preact/hooks";
import Image from "apps/website/components/Image.tsx";
import Icon from "$store/components/ui/Icon.tsx";
import Button from "$store/components/ui/Button.tsx";
import type { ImageWidget } from "apps/admin/widgets.ts";

export interface CoverFlowSliderProps {
  coverFlowImages: ImageWidget[];
}

function CoverFlowSlider({ coverFlowImages = [] }: CoverFlowSliderProps) {
  const MAX_VISIBILITY = 3;
  const [active, setActive] = useState(2);
  const count = coverFlowImages.length;

  return (
    <div class="relative w-[23rem] h-[25rem] m-auto coverflow-slide lg:ml-auto lg:mr-13">
      <Button
        class="no-animation group/prev absolute  left-0 z-10  lg:left-8 top-1/2   btn-circle  bg-tw-primary-100  hover:bg-tw-primary-200  flex justify-center items-center opacity-100 duration-300 transition-all disabled:bg-white disabled:opacity-50"
        onClick={() => {
          if (active <= 0) return;
          setActive((i) => i - 1);
        }}
        disabled={active === 0}
      >
        <Icon
          size={20}
          id="ChevronLeft"
          strokeWidth={3}
          class="text-white group-disabled/prev:text-tw-neutral-500"
        />
      </Button>
      {coverFlowImages.map((img, i) => (
        <div
          class="card-container"
          style={{
            "--active": i === active ? 1 : 0,
            "--offset": (active - i) / 3,
            "--direction": Math.sign(active - i),
            "--abs-offset": Math.abs(active - i) / 3,
            "pointer-events": active === i ? "auto" : "none",
            "opacity": i === active
              ? "1"
              : Math.abs(active - i) >= 2
              ? "0"
              : "0.5",
            "display": Math.abs(active - i) > MAX_VISIBILITY ? "none" : "block",
          }}
        >
          <div className="card w-full h-full transition-all duration-300 ease-in-out p-4">
            <Image
              src={img}
              width={343}
              height={374}
              class="w-full"
              loading="lazy"
              fetchPriority="low"
            />
          </div>
        </div>
      ))}
      <Button
        class="no-animation absolute group/next z-10  right-0 lg:right-8 top-1/2 rotate-180  btn-circle bg-tw-primary-100 flex  hover:bg-tw-primary-200 justify-center items-center opacity-100 duration-300 transition-all disabled:bg-white disabled:opacity-50"
        onClick={() => {
          if (active >= count - 1) return;
          setActive((i) => i + 1);
        }}
        disabled={active >= count - 1}
      >
        <Icon
          size={20}
          id="ChevronLeft"
          strokeWidth={3}
          class="text-white group-disabled/next:text-tw-neutral-500"
        />
      </Button>
    </div>
  );
}

export default CoverFlowSlider;
